module.exports = __webpack_public_path__ + "img/hrob01.9cadb159.png";